import { usePage } from '@inertiajs/react';
import Theme1CustomerLayout from '@/theme1/layouts/customer-layout';
import Theme2CustomerLayout from '@/theme2/layouts/customer-layout';
import Theme3CustomerLayout from '@/theme3/layouts/customer-layout';

export default function SettingsLayout({ children }) {
    const { frontendTheme } = usePage().props;
    const CustomerLayout =
        frontendTheme?.name === 'theme3'
            ? Theme3CustomerLayout
            : frontendTheme?.name === 'theme2'
                ? Theme2CustomerLayout
                : Theme1CustomerLayout;

    return <CustomerLayout>{children}</CustomerLayout>;
}
